import { DropdownGroupReg } from '../types/ViewModel/DropdownGroupReg';
import { DropdownGroup } from '../types/ViewModel/DropdownGroup';
import { DropdownItemReg } from '../types/ViewModel/DropdownItemReg';
import { DropdownTypeEnum } from '../enums/dropdownTypeEnum';
import { DropdownGroupRegBM } from '../types/BusinessModel/DropdownGroupRegBM';
import { SelectOption } from '../types/ViewModel/SelectOption';
import eventtypecommon from '../utils/event/eventtypecommon';
import DropdownItemRegFactory from './DropdownItemRegFactory';

export default () => {
    const { generateUuid } = eventtypecommon();
    const { newDropdownItemRegArray, createDropdownItemRegArray, setDropdownItemRegFromSelection, createDropdownItemRegListBM } =
        DropdownItemRegFactory();

    const newDropdownGroupReg = (dropdownGroupReg: DropdownGroupRegBM): DropdownGroupReg => {
        let dropdownGroupRegId: string;
        if (dropdownGroupReg.dropdownGroupRegId) {
            dropdownGroupRegId = dropdownGroupReg.dropdownGroupRegId;
        } else {
            dropdownGroupRegId = generateUuid();
        }
        return new DropdownGroupReg(
            dropdownGroupRegId,
            dropdownGroupReg.dropdownTypeId,
            dropdownGroupReg.eventInputDropdownGroupId,
            newDropdownItemRegArray(dropdownGroupReg.dropdownItemRegList)
        );
    };

    const createDropdownGroupFromCode = (
        dropdownGroupRegId: string,
        dropdownTypeId: DropdownTypeEnum,
        eventInputDropdownGroupId: number,
        dropdownItemRegList: DropdownItemReg[]
    ): DropdownGroupReg => {
        return new DropdownGroupReg(dropdownGroupRegId, dropdownTypeId, eventInputDropdownGroupId, createDropdownItemRegArray(dropdownItemRegList));
    };

    const createDropdownGroupRegArray = (dropdownGroupRegArray: DropdownGroupReg[]): DropdownGroupReg[] => {
        if (dropdownGroupRegArray && dropdownGroupRegArray.length > 0) {
            const dropdownRegList: DropdownGroupReg[] = [];
            dropdownGroupRegArray.map((reg) => {
                const item = createDropdownGroupReg(reg);
                if (item) {
                    dropdownRegList.push();
                }
            });
            return dropdownRegList;
        }
        return [];
    };

    const createDropdownGroupReg = (dropdownGroupReg: DropdownGroupReg | null): DropdownGroupReg | null => {
        if (dropdownGroupReg) {
            return new DropdownGroupReg(
                dropdownGroupReg.dropdownGroupRegId,
                dropdownGroupReg.dropdownTypeId,
                dropdownGroupReg.eventInputDropdownGroupId,
                createDropdownItemRegArray(dropdownGroupReg.dropdownItemRegList)
            );
        }
        return null;
    };

    const newDropdownGroupRegFromDropdownGroup = (dropdownGroup: DropdownGroup): DropdownGroupReg => {
        return new DropdownGroupReg(generateUuid(), dropdownGroup.dropdownTypeId, dropdownGroup.eventInputDropdownGroupId, []);
    };

    const newDropdownGroupRegWithSelItems = (
        dropdownType: DropdownTypeEnum,
        evInpDdGroupId: number,
        selectionArray: SelectOption[]
    ): DropdownGroupReg => {
        return new DropdownGroupReg(generateUuid(), dropdownType, evInpDdGroupId, setDropdownItemRegFromSelection(selectionArray));
    };

    const getDropdownGroupRegFromDropdownGroup = (dropdownGroup: DropdownGroup, dropdownItemRegList: DropdownItemReg[]): DropdownGroupReg => {
        return new DropdownGroupReg(
            generateUuid(),
            dropdownGroup.dropdownTypeId,
            dropdownGroup.eventInputDropdownGroupId,
            createDropdownItemRegArray(dropdownItemRegList)
        );
    };

    const createDropdownGroupRegBM = (dropdownGroupReg: DropdownGroupReg | null): any => {
        if (dropdownGroupReg) {
            return {
                dropdownGroupRegId: dropdownGroupReg.dropdownGroupRegId,
                dropdownTypeId: dropdownGroupReg.dropdownTypeId,
                eventInputDropdownGroupId: dropdownGroupReg.eventInputDropdownGroupId,
                dropdownItemRegList: createDropdownItemRegListBM(dropdownGroupReg.dropdownItemRegList),
            };
        }
        return null;
    };

    return {
        newDropdownGroupReg,
        createDropdownGroupFromCode,
        createDropdownGroupRegArray,
        createDropdownGroupReg,
        newDropdownGroupRegFromDropdownGroup,
        newDropdownGroupRegWithSelItems,
        getDropdownGroupRegFromDropdownGroup,
        setDropdownItemRegFromSelection,
        createDropdownGroupRegBM,
    };
};
